
export const ERROR_CODE = {
  NEGATIVE_BALANCE: '0100-0039',
  MULTIPLE_SUBSCRIPTION: '1100-0037',
  MULTIPLE_BINDING: '0100-0016',
  PLAY_EMAIL_IN_USE: '0100-0050',
  OUT_OF_STOCK: '00007',
  QUARANTINE: '0100-0053',
  CHANGE_IN_PROGRESS: '2100-0015',
  BINDING: '2100-0007',
  SUB_USER_1: 'COMMERCE.0004',
  SUB_USER_2: 'COMMERCE.0005',
  CVR_NO_MATCH: '00008',
  CHANGE_SUB_NEGATIVE_BALANCE_1: '2100-0009',
  CHANGE_SUB_NEGATIVE_BALANCE_2: '2100-0010'
}

export const WARNING_CODE = {
  CHANGE_END_OF_MONTH: ['0100-0054', '0100-0056'],
  CHANGE_END_OF_DAY: '0100-0055'
}
export const SIGN_UP_ERROR_TYPES = {
  NEGATIVE_BALANCE: 'negativeBalance',
  MULTIPLE_SUBSCRIPTION: 'multipleSubscriptions'
}
